/**
 * Trunnion AI - Chat React Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chatApi } from '@/api/chat.api';

const chatKeys = {
  all: ['chat'] as const,
  sessions: (agentId: string) => [...chatKeys.all, 'sessions', agentId] as const,
  history: (agentId: string, sessionId: string) =>
    [...chatKeys.all, 'history', agentId, sessionId] as const,
};

export function useChatSessions(agentId: string) {
  return useQuery({
    queryKey: chatKeys.sessions(agentId),
    queryFn: () => chatApi.listSessions(agentId),
    enabled: !!agentId,
  });
}

export function useChatHistory(agentId: string, sessionId: string | null) {
  return useQuery({
    queryKey: chatKeys.history(agentId, sessionId ?? ''),
    queryFn: () => chatApi.getHistory(agentId, sessionId!),
    enabled: !!agentId && !!sessionId,
  });
}

export function useDeleteChatSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sessionId: string) => chatApi.deleteSession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: chatKeys.all });
    },
  });
}
